import { Container, } from "reactstrap";
import "./CAD_Hero_Section.css";

import { Button, Col, Form, FormGroup, Input, Row } from "reactstrap";
import { createEnquiry } from "../../apiUrlConst";
import { toast } from "react-toastify";
import {
    FiCheckCircle,
    FiMail,
    FiMessageSquare,
    FiPhone,
    FiSend,
    FiUser,
} from "react-icons/fi";

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const cadSoftware = [
    {
        name: "NX",
        path: "/nx-open-customization-automation-training",
    },
    {
        name: "CATIA",
        path: "/catia-caa-customization-automation-training",
    },
    {
        name: "CREO",
        path: "/creo-toolkit-customization-training",
    },
    {
        name: "SolidWorks",
        path: "/solidworks-api-customization-automation-training",
    },
    {
        name: "Inventor",
        path: "/autodesk-inventor-api-customization-automation-course",
    },
    {
        name: "AutoCAD",
        path: "/autocad-api-customization-automation-online-courses",
    },
    {
        name: "Revit",
        path: "/autodesk-revit-api-customization-automation-course",
    },
    {
        name: "Teamcenter",
        path: "/teamcenter-plm-customization-training-itk-rac-soa-awc",
    },
    {
        name: "Windchill",
        path: "/ptc-windchill-plm-customization-course",
    },
];

function CADHeroSection({
    title,
    intro,
    sections = []
}) {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        purpose: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);


    /* =========================================
       HANDLE INPUT
    ========================================= */

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    /* =========================================
       RESET FORM
    ========================================= */

    const resetForm = () => {

        setFormData({
            name: "",
            email: "",
            phoneNumber: "",
            purpose: "",
            message: ""
        });
    };


    /* =========================================
       CLOSE MODAL
    ========================================= */




    /* =========================================
       SUBMIT
    ========================================= */

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            setLoading(true);

            const submitData = {
                ...formData,

                purpose:
                    formData.purpose

            };

            await createEnquiry(submitData);

 navigate("/thankyou");
            toast.success(
                "Thank you! Your enquiry has been submitted successfully."
            );

            resetForm();


        } catch (error) {

            console.error(
                "Course enquiry error:",
                error
            );

            toast.error(
                "Unable to submit your enquiry. Please try again."
            );

        } finally {

            setLoading(false);
        }
    };
    return (
        <section className="cad-hero-wrapper">

            <div className="cad-hero-grid"></div>
            <div className="cad-hero-glow cad-hero-glow-one"></div>
            <div className="cad-hero-glow cad-hero-glow-two"></div>

            <Container className="position-relative">

                <Row className="mb-0 cad-contact-row align-items-center">

                    <Col
                        lg="8"
                        className="cad-hero-content mb-0"
                    >

                       

                        <h1 className="cad-hero-title ">
                            {title}
                        </h1>
 <div className="cad-hero-label mt-3">
                           Step by Step . Live . Interactive . Online Training
                        </div>


                        <p className="cad-hero-intro mt-2">
                            {intro}
                        </p>

                        <div className="cad-benefits">

                            <div className="cad-benefit-item mt-2">
                                <div className="cad-benefit-icon">
                                    <FiCheckCircle />
                                </div>

                                <div>
                                    <h6>Industry-Focused Training</h6>
                                    <p>
                                        Learn practical concepts used in
                                        real-world CAD automation projects.
                                    </p>
                                </div>
                            </div>

                            <div className="cad-benefit-item">
                                <div className="cad-benefit-icon">
                                    <FiCheckCircle />
                                </div>

                                <div>
                                    <h6>Learn from Working Professionals</h6>
                                    <p>
                                        Get guidance from experienced
                                        professionals working in the industry.
                                    </p>
                                </div>
                            </div>

                            <div className="cad-benefit-item">
                                <div className="cad-benefit-icon">
                                    <FiCheckCircle />
                                </div>

                                <div>
                                    <h6>Start with free Classes and Pay in Easy Installments</h6>
                                    <p>
                                        Work on practical projects and
                                        automation scenarios.
                                    </p>
                                </div>
                            </div>

                        </div>



                    </Col>


                    {/* =====================================
                        RIGHT CONTACT FORM
                    ===================================== */}
                    <Col
                        lg="4"
                        className="cad-form-column mb-0"
                    >

                        <div className="cad-enquiry-card">

                            {/* Form Header */}
                            <div className="cad-form-header">

                                <div className="cad-form-icon">
                                    <FiMessageSquare />
                                </div>

                                <div>
                                    {/* <span className="cad-form-eyebrow">
                                        GET STARTED
                                    </span> */}

                                    <h2>
                                        Let's Connect
                                    </h2>

                                    <p>
                                        Have questions about the course?
                                        Send us your details and our team
                                        will get back to you.
                                    </p>
                                </div>

                            </div>


                            {/* Form */}
                            <Form onSubmit={handleSubmit}>

                                <Row>

                                    {/* NAME */}
                                    <Col md="12">

                                        <FormGroup className="cad-form-group">

                                            <div className="cad-input-wrapper">

                                                <FiUser />

                                                <Input
                                                    type="text"
                                                    name="name"
                                                    placeholder="Your Name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                        </FormGroup>

                                    </Col>


                                    {/* PHONE */}
                                    <Col md="12">

                                        <FormGroup className="cad-form-group">



                                            <div className="cad-input-wrapper">

                                                <FiPhone />

                                                <Input
                                                    type="tel"
                                                    name="phoneNumber"
                                                    placeholder="Your Phone Number"
                                                    value={formData.phoneNumber}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                        </FormGroup>

                                    </Col>


                                    {/* EMAIL */}
                                    <Col md="12">

                                        <FormGroup className="cad-form-group">



                                            <div className="cad-input-wrapper">

                                                <FiMail />

                                                <Input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Your Email Address"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />

                                            </div>

                                        </FormGroup>

                                    </Col>


                                    {/* MESSAGE */}
                                    <Col md="12">

                                        <FormGroup className="cad-form-group">



                                            <div className="cad-textarea-wrapper">

                                                <FiMessageSquare />

                                                <Input
                                                    type="textarea"
                                                    name="message"
                                                    placeholder="Briefly explain your requirements..."
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    rows="5"
                                                    required
                                                />

                                            </div>

                                        </FormGroup>

                                    </Col>


                                    {/* SUBMIT */}
                                    <Col md="12">

                                        <Button
                                            type="submit"
                                            className="cad-submit-button"
                                            disabled={loading}
                                        >

                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Submitting...
                                                </>
                                            ) : (
                                                <>
                                                    Submit 
                                                    <FiSend />
                                                </>
                                            )}

                                        </Button>

                                    </Col>

                                </Row>

                            </Form>


                            {/* Footer */}
                            {/* <div className="cad-form-footer">

                                <FiCheckCircle />

                                <span>
                                    Your information is safe with us.
                                    We will contact you shortly.
                                </span>

                            </div> */}

                        </div>

                    </Col>

                </Row>

 <div className="cad-software-navigation">

            {cadSoftware.map((software) => (
                <Link
                    key={software.name}
                    to={software.path}
                    className="cad-software-link"
                >
                    {software.name}
                </Link>
            ))}

        </div>

                <Row className="cad-content-row">

                    {sections.map((section, index) => (

                        <Col
                            lg={index === 0 || index === 3 ? "12" : "6"}
                            md="12"
                            key={index}
                        >

                            <article
                                className={`cad-content-card ${index === 0
                                    ? "cad-featured-card"
                                    : ""
                                    }`}
                            >

                                <div className="cad-card-top">

                                    <div className="cad-card-number">
                                        {String(index + 1).padStart(2, "0")}
                                    </div>

                                    <div className="cad-card-heading-line"></div>

                                    <div className="cad-card-category">
                                        CAD TRAINING
                                    </div>

                                </div>


                                <h2 className="cad-card-title">
                                    {section.title}
                                </h2>

                                <p className="cad-card-text">
                                    {section.content}
                                </p>


                                <div className="cad-card-accent"></div>

                            </article>

                        </Col>

                    ))}

                </Row>

            </Container>

        </section>
    );
}

export default CADHeroSection;